import VueSlider from 'vue-slider-component';
export default function(VueInstance) {
  VueInstance.component('VueSlider', VueSlider);
}
